import { useLayoutEffect, useState } from "react";
import { DETAILS_PHONE_LAYOUT_BELOW } from "./tablesLayout";

/**
 * Дясната част на „Маркиране" (поръчаното, `OrderDetails`) на десктоп в
 * „Списък": стеснена ли е под DETAILS_PHONE_LAYOUT_BELOW от разтеглената релса
 * с масите (`RailResizeHandle`). Тогава е изцяло като на телефон — редовете на
 * няколко реда, без нищо скрито. Мери се ширината на самия елемент
 * (ResizeObserver), не на екрана — `useViewport` не я знае.
 */
export const useDetailsPhoneLayout = (element: HTMLElement | null, enabled: boolean): boolean => {
  const [narrow, setNarrow] = useState(false);
  useLayoutEffect(() => {
    if (!enabled || !element) return;
    const update = () => setNarrow(element.clientWidth < DETAILS_PHONE_LAYOUT_BELOW);
    update();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, enabled]);
  return enabled && narrow;
};
